import { requestGet } from '@/common/request';

export interface categoryListParams {
  activityId: string;
}

export interface categoryListRes {
  ret: string;
  msg: string;
  data: { list: Array<{ categoryCode: string; categoryName: string }> | [] };
}

//品类盘货 - 类目筛选器列表
export async function categoryList(params: categoryListParams): Promise<categoryListRes> {
  return await requestGet('/goodsPool/categoryList', params);
}
